import { useAuth, overrideConfig } from '@/api/billing-primary'

const fetchInvoiceMonths = function ({ usageAccountId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/months`)
}

const fetchInvoiceAnnualSummary = function ({ usageAccountId, year }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/${usageAccountId}/years/${year}`)
}

/**
 * 그룹의 최신 발행월. 기간 셀렉터 상한으로 쓴다.
 * 단순 MAX 가 아니라 중간정산 마감일 판정까지 반영된 값이다.
 */
const fetchBulkLatestMonth = function ({ groupIdx }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/group/${groupIdx}/latest-month`)
}

/** 일괄 생성 요청. 접수만 하고 202 로 즉시 응답한다(생성은 서버 워커). */
const requestBulkDownload = function ({ groupIdx, payload }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post(`/v1/hyper-common/invoice/group/${groupIdx}/bulk`, payload)
}

/** 요청 목록. 만료된 건은 서버가 제외해서 내려준다. */
const fetchBulkJobs = function (serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get('/v1/hyper-common/invoice/bulk/jobs')
}

/** 폴링용 단건 조회. 완료된 월은 downloadable=true 로 표시된다(URL 은 없다). */
const fetchBulkJob = function ({ jobId }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/bulk/jobs/${jobId}`)
}

/**
 * 다운로드 URL 발급 — 버튼을 누른 시점에 호출한다.
 *
 * 목록·폴링 응답에는 URL 이 실리지 않는다. presigned URL 은 보유 자체가 권한이라,
 * 미리 받아두면 목록을 여는 것만으로 전 건의 URL 이 브라우저에 남기 때문이다(BO-964).
 */
const fetchBulkDownloadUrl = function ({ jobId, month }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.get(`/v1/hyper-common/invoice/bulk/jobs/${jobId}/months/${month}/download-url`)
}

/**
 * 완료된 ZIP 을 메일로 보내달라고 요청한다(BO-983).
 *
 * 첨부 여부·크기는 서버가 저장된 값으로 판단하므로 수신자만 보낸다.
 */
const sendBulkMail = function ({ jobId, month, emails }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post(
        `/v1/hyper-common/invoice/bulk/jobs/${jobId}/months/${month}/send-mail`,
        { emails }
    )
}

export default {
    fetchInvoiceMonths,
    fetchInvoiceAnnualSummary,
    fetchBulkLatestMonth,
    requestBulkDownload,
    fetchBulkJobs,
    fetchBulkDownloadUrl,
    sendBulkMail,
    fetchBulkJob
}
